export const TRIAL_ELIGIBILITY_STATUS = 'TRIAL_ELIGIBILITY_STATUS';

export const UPDATE_PERSONAL_DATA_REQUEST = 'UPDATE_PERSONAL_DATA_REQUEST';
export const UPDATE_PERSONAL_DATA_SUCCESS = 'UPDATE_PERSONAL_DATA_SUCCESS';
export const UPDATE_PERSONAL_DATA_FAILURE = 'UPDATE_PERSONAL_DATA_FAILURE';

export const TOOL_BUTTON_NAMES = {
  USER: 'User',
  LICENSE: 'License',
  FJU: 'FJU',
  HELP: 'Help',
};
